import { render, staticRenderFns } from "./ReviewsPortalCard.vue?vue&type=template&id=2610a82e&scoped=true&"
import script from "./ReviewsPortalCard.vue?vue&type=script&lang=js&"
export * from "./ReviewsPortalCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPortalCard.vue?vue&type=style&index=0&id=2610a82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610a82e",
  null
  
)

export default component.exports